export default __webpack_public_path__ + "static/media/The Field Trip.55b8fb67.pdf";